
export enum ProductMappingSnackbarMessage {
  MappingCreate = 'Product mapping created',
  MappingUpdate = 'Product mapping updated',
  WentWrong = 'Something went wrong!'
}